var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeIco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.113)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    transform: "translate(0 -0.113)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.323 1.162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.619,4.9l9.3,8.482v10.69H20.848V15.885a1.162,1.162,0,0,0-1.162-1.162H11.552a1.162,1.162,0,0,0-1.162,1.162v8.192H6.323V13.387l9.3-8.482m0-2.9a.639.639,0,0,0-.407.174L4.348,11.993A1.162,1.162,0,0,0,4,12.864V26.4h8.715V17.047h5.81V26.4h8.715V12.864a1.162,1.162,0,0,0-.349-.871L16.026,2.174A.639.639,0,0,0,15.619,2Z",
    transform: "translate(-3.999 -2)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIco);
export default __webpack_public_path__ + "static/media/home-ico.ec00e472ce4027fdf442516a16e9eac8.svg";
export { ForwardRef as ReactComponent };